/**
 * Created by xiajing on 2017/7/11.
 */
import * as types from '../constants/ActionTypes'
import { handleActions } from 'redux-actions'
const reducers = {}
const initialState = {
    currentStatus: 'close',
    showFull:'close'
}
reducers[types.CURRENT_CALL_REQ] = (state, action) => {
    return Object.assign({}, state, {currentCallReq:action.payload.call,currentCustomer:action.payload.customer})
}
reducers[types.CURRENT_CALL_STATUS] = (state, action) => {
    return Object.assign({}, state, {currentStatus:action.payload.status})
}
reducers[types.SHOW_FULL_SCREEN] = (state, action) => {
    return Object.assign({}, state, {showFull:action.payload.type})
}

reducers[types.START_SESSION_FINISH] = {
    next(state, action) {

        if(!action.error){
            return Object.assign({}, state, {currentCustomer: action.payload.serviceRequest})
        }
        else{
            return state
        }
    }
}

reducers['END_CALL'] = (state, action) => {

    return Object.assign({}, state, {currentCustomer: action.payload})
}
export default handleActions(reducers, initialState)
